module.exports = {"id":"193945","name":"Necip Uysal","rating":"73","photo":"./data/images/photos/0/193945.png","club":{"name":"Beşiktaş","logo":"./data/images/clubs/Besiktas.png"},"positions":["MDC","DC","DD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/NecipUysal0.json
// module id = 3148
// module chunks = 0